import store from '../store'

export function handleResponse(response) {
  const { data } = response
  if (!(response.status >= 200 && response.status <= 299)) {
    const fromCMSService = response.request.responseURL.includes(
      window.config.VUE_APP_CMS_API_BASE_URL
    )
    if (response.status === 401 && !fromCMSService) {
      // commit only when the user is already loggedIn
      if (store.getters.isAuthenticated) {
        store.commit('sessionTimeOut')
      }
    }

    const error = data || response
    return Promise.reject(error)
  }
  return data
}

export function handleError(e) {
  if (e instanceof Error && e.message === 'Network Error') {
    e.response = { status: '503' }
    return Promise.reject(e)
  }
  if (!(e.response.status === 200)) {
    const fromCMSService = e.request.responseURL.includes(
      window.config.VUE_APP_CMS_API_BASE_URL
    )
    if (e.response.status === 401 && !fromCMSService) {
      // commit only when the user is already loggedIn
      if (store.getters.isAuthenticated) {
        store.commit('sessionTimeOut')
      }
    }
    return Promise.reject(e)
  }
  return Promise.reject(e)
}
